import { render, staticRenderFns } from "./StomachPlan.vue?vue&type=template&id=55ee3580&scoped=true&"
import script from "./StomachPlan.vue?vue&type=script&lang=js&"
export * from "./StomachPlan.vue?vue&type=script&lang=js&"
import style0 from "./StomachPlan.vue?vue&type=style&index=0&id=55ee3580&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ee3580",
  null
  
)

export default component.exports